<script setup>
// クライアントサイドレンダリングのみ
definePageMeta({
  mode: 'spa'
})

const route = useRoute()
const gpsInfo = ref(null)
const cityName = ref('')
const breadCrumbList = ref([])
const cityInfo = ref({})
const showHistory = ref([])
const shortData = ref([])
const midrangeData = ref([])
const graphData = ref({})

const isLoading = ref(true)
onMounted(async () => {
  try {
    // check param
    const llinfo = { lat: route.query?.lat, lon: route.query?.lon }
    const gpsInfoData = await $fetch('/api/city/gpsinfo', { query: llinfo })
    gpsInfo.value = gpsInfoData
    cityName.value = gpsInfo.value?.name || ''

    if (!cityName.value) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Invalid URL(gps)'
      })
    }

    // seo info
    breadCrumbList.value = (gpsInfo.value?.breadCrumbList || [])

    const cityCode = gpsInfo.value?.code || ''
    cityInfo.value = { // ccode ページの書き振りに合わせる
      areacode: gpsInfo.value?.area?.roma || '',
      areaname: gpsInfo.value?.area?.title || '',
      prefcode: gpsInfo.value?.prefcode?.roma || '',
      prefname: gpsInfo.value?.prefcode?.title || '',
      citycode: cityCode,
      cityname: cityName.value,
      lat: Number(route.query?.lat || 0),
      lon: Number(route.query?.lon || 0),
      area: gpsInfo.value?.prefcode?.roma || ''
    }

    useCustomMetaPoint({ pointName: cityName.value, path: route.path, wntouch: true, type: 'point' })
    useCustomJsonldPoint({ breadCrumbList: breadCrumbList.value })

    // save and read history
    const newHistory = deepCopy({ ...cityInfo.value, historyKey: cityName.value, link: '/clothes' + route.path + '?lat=' + route.query?.lat + '&lon=' + route.query?.lon })
    showHistory.value = addHistory(newHistory)

    // get and prop data
    const pinpointData = await $fetch('/api/clothes/pinpoint', { query: { lat: route.query?.lat, lon: route.query?.lon, citycode: cityCode } })
    shortData.value = pinpointData?.short || []
    midrangeData.value = pinpointData?.midrange || []
    graphData.value = pinpointData?.graphData || {}
    if (graphData.value?.current) {
      graphData.value.cityName = cityInfo.value?.cityname
    }
  } catch (error) {
    console.error('GPS page error:', error)
    throw createError({
      statusCode: 404,
      statusMessage: 'Invalid URL(gps)'
    })
  } finally {
    isLoading.value = false
  }
})
</script>

<template>
  <div>
    <ClientOnly>
      <div
        v-if="isLoading"
        class="loading-container"
      >
        <div class="loading-spinner" />
        <p>loading...</p>
      </div>
      <NuxtLayout
        v-if="!isLoading"
        :bread-crumb-list="breadCrumbList"
        ads-key="area"
        name="common"
      >
        <ClothesShortForecast
          :short-data="shortData"
          :city-info="cityInfo"
        />
        <!-- ads-atf のみ、Layout 内部にあるので、個別に記載。(他の広告は layout/common.vue に記載) -->
        <div
          id="2.5web_clothes_atf"
          class="ads-atf"
        />
        <ClothesWeekForecast
          :midrange-data="midrangeData"
          :city-info="cityInfo"
        />
        <ClothesLegend />
        <tempGraph :graph-data="graphData" />
        <ClothesHistory :history-data="showHistory" />
      </NuxtLayout>
    </ClientOnly>
  </div>
</template>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container {
  text-align: center;
  padding: 30px;
  background-color: #fef2f2;
  border-radius: 8px;
  color: #b91c1c;
}

.error-container button {
  background-color: #3b82f6;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  margin-top: 15px;
  cursor: pointer;
}
</style>
